import {
	type ApiV1,
} from '@teamworksdev/influencer/core';

const isMediaGallery = (media: ApiV1.Media | ApiV1.MediaGallery): media is ApiV1.MediaGallery => {
	return 'gallery' in media;
};


export {
	isMediaGallery,
};
